<template>
  <a :href="attendeeUrl" target="_blank"
     class="chat-status-attendee" :class="{'active': isOnline}">
    <div class="chat-status-attendee-name">
      <AttendeeOnline v-if="isOnline" />
      {{ presence.name }}
    </div>
    <!-- Hide the org this is a solo attendee -->
    <div v-if="presence.name != presence.organisation_name"
         class="chat-status-organisation-name">{{ presence.organisation_name }}
    </div>

    <div v-if="!isOnline"
         class="last-seen">Last here: {{ asDateTimeStamp(presence.timestamp) }}
    </div>
  </a>
</template>

<script>
// import {CHAT_TYPES, CHAT_SUBTYPES} from "../Config";
import AttendeeOnline from "@/components/AttendeeOnline";
import {asDateTimeStamp} from "../DateTime";

export default {
  name: "ChatPresence",
  props: {
    presence: Object, // {attendee_id, name, organisation_name, timestamp}
    isOnline: {
      type: Boolean
    }
  },
  components: {
    AttendeeOnline,
  },
  computed: {
    attendeeUrl() {
      return `/search/attendees?id=${this.presence.attendee_id}`;
    },
    // isActive() {
    //   return this.status.subtype === CHAT_SUBTYPES.JOIN;
    // },
    // isBanned() {
    //   return this.status.type === CHAT_TYPES.BANNED;
    // }
  },
  methods: {
    asDateTimeStamp,
  }
}
</script>

<style>
.chat-status-attendee {
  display: block;
  margin: 5px;
  padding: 10px;
  background-color: #eee;
  color: #999;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.chat-status-attendee.active {
  background-color: #fff;
  color: #333;
}

.chat-status-attendee.banned {
  background-color: #f2dede;
  color: #b94a48;
  text-decoration: line-through;
}

.chat-status-attendee:hover {
  color: #999;
}

.chat-status-attendee:hover,
.active.chat-status-attendee:hover {
  background-color: #f6f6f6;
  text-decoration: none;
}

.active .chat-status-organisation-name {
  color: #666;
}

.last-seen {
  border-top: 1px solid #999;
  font-size: 10px;
  font-style: italic;
}
</style>